import React, {useState, useEffect} from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Col, Form, Row } from 'react-bootstrap'
import { toast } from 'react-toastify';
import axios from 'api/axios';
import moment from 'moment/moment';

import PageHeader from 'components/common/PageHeader';
import DataCard from 'components/mycomponents/DataCard';
import ModalAlert from 'components/mycomponents/ModalAlert';

import Config from 'utils/config';

import Data from './Data';
import VehicleForm from './Form';
import Detail from './Detail';

const Vehicle = () => {
    // Declare State Variable
    const [data, setData] = useState(null);
    const [totalIncome, setTotalIncome] = useState(0);
    const [totalData, setTotalData] = useState(0);
    const [showForm, setShowForm] = useState(false);
    const [showDetail, setShowDetail] = useState(false);
    const [keyword, setKeyword] = useState({q:'', report_type: 1, parking_location: 0, vehicle_type: 0, fromDate: moment().format('YYYY-MM-DD'), toDate: moment().format('YYYY-MM-DD'), month: moment().format('M'), year: moment().format('YYYY')});
    const [pagination, setPagination] = useState({disabledPrev: true, disabledNext: false, pageTotal: 0, currentPage: 1, limit: 10, numberStart: 0});
    const [loadingData, setLoadingData] = useState(false);
    const [loadingForm, setLoadingForm] = useState(false);
    const [showAlert, setShowAlert] = useState({show: false, message: '', type: '', confirmButton: false});
    const [validateForm, setValidateForm] = useState(false);
    const [formAttribute, setFormAttribute] = useState({
        title: 'Form', 
        type: 'add',
        data: {
            vckode:'',
            vcnama:'',
            vcnopol:'',
            inttypeangkutan:'',
            intrute_angkutan_id:''
        }
    });
    const [dataList, setDataList] = useState({parking_location: null, vehicle_type: null});

    // Declare Constant Variable
    const navigate = useNavigate();
    const DATA_URL = '/parking';
    const DATA_URL_LIST = '/lists';
    const ACCESS_USER = JSON.parse(localStorage.getItem('accessUser'));
    const TOKEN_APP = ACCESS_USER ? ACCESS_USER.token : '';
    const HEADER_AUTHORIZATION = {
        headers: {
          'Authorization': `Bearer ${TOKEN_APP}`
        }
    };

    // function get data
    const getData = async (page = 1, limit = 10) => {
        setLoadingData(true);
        try {
            const response = await axios.get(`${DATA_URL}?q=${keyword.q}&from=${keyword.fromDate}&to=${keyword.toDate}&parking_location=${keyword.parking_location}&vehicle_type=${keyword.vehicle_type}&page=${page}&limit=${limit}`, HEADER_AUTHORIZATION);
            const responseResult = response?.data;
            const responseData = responseResult?.data;
            const responseDataLength = responseResult?.length;
            const responseDataPageTotal = responseResult?.page_total;
            const responseDataIncome = responseResult?.total_income;
            const responseDataTotal = responseResult?.total_data;

            setTotalIncome(responseDataIncome)
            setTotalData(responseDataTotal)

            if (responseDataLength > 0) {
                setData(responseData);
                setPagination(prevState => {
                    return {...prevState, pageTotal: responseDataPageTotal, limit: limit, currentPage: page, numberStart: limit * (page - 1)}
                })
            } else {
                setData(null);
            }
            if (page >= responseDataPageTotal) {
                setPagination(prevState => {
                    return {...prevState, disabledNext: true}
                })
            } else {
                setPagination(prevState => {
                    return {...prevState, disabledNext: false}
                })
            }
            if (page === 1) {
                setPagination(prevState => {
                    return {...prevState, disabledPrev: true}
                })
            }
            setLoadingData(false);
            
        } catch (err) {
            setLoadingData(false);
            if (err.response) {
                if (err?.response.status === 401) {
                    toast.error(err?.response.data.message);
                    localStorage.removeItem('accessUser');
                    navigate('/login');
                } else {
                    const response = err.response.data;
                    setShowAlert(prevState => { return {...prevState, show: true, message: response.message, type: 'error'} })
                }
            } else {
                setShowAlert(prevState => { return {...prevState, show: true, message: 'Something error with server. Please call administrator or developer.', type: 'error'} })
            }
        }
    }

    // Get Data On Load
    // useEffect(() => {
    //     getData();
    // // eslint-disable-next-line react-hooks/exhaustive-deps
    // }, []);

    useEffect(() => {
        const getListLocation = async () => {
            try {
                const response = await axios.get(`${DATA_URL_LIST}/parking_location`, HEADER_AUTHORIZATION);
                const responseResult = response?.data;
                setDataList(prevState => { return {...prevState, parking_location: responseResult?.data} });
            } catch (err) {
                setLoadingData(false);
                if (err.response) {
                    const response = err.response.data;
                    setShowAlert(prevState => { return {...prevState, show: true, message: response.message, type: 'error'} })
                } else {
                    setShowAlert(prevState => { return {...prevState, show: true, message: 'Something error with server. Please call administrator or developer.', type: 'error'} })
                }
            }
        }
        
        const getListVehicleType = async () => {
            try {
                const response = await axios.get(`${DATA_URL_LIST}/vehicle_type`, HEADER_AUTHORIZATION);
                const responseResult = response?.data;
                setDataList(prevState => { return {...prevState, vehicle_type: responseResult?.data} });
            } catch (err) {
                setLoadingData(false);
                if (err.response) {
                    const response = err.response.data;
                    setShowAlert(prevState => { return {...prevState, show: true, message: response.message, type: 'error'} })
                } else {
                    setShowAlert(prevState => { return {...prevState, show: true, message: 'Something error with server. Please call administrator or developer.', type: 'error'} })
                }
            }
        }

        getListLocation()
        getListVehicleType()
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[])

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const keywordParam = urlParams.get('q');
        const parkingLocationParam = urlParams.get('parking_location');
        const vehicleTypeParam = urlParams.get('vehicle_type');
        const fromDateParam = urlParams.get('from');
        const toDateParam = urlParams.get('to');

        const keywordValue = keywordParam ? keywordParam : '';
        const parkingLocationValue = parkingLocationParam ? parkingLocationParam : 0;
        const vehicleTypeValue = vehicleTypeParam ? vehicleTypeParam : 0;
        const fromDateValue = fromDateParam ? fromDateParam : moment().format('YYYY-MM-DD');
        const toDateValue = toDateParam ? toDateParam : moment().format('YYYY-MM-DD');

        let keywordTemp = keyword;
        keywordTemp.q = keywordValue
        keywordTemp.parking_location = parkingLocationValue
        keywordTemp.vehicle_type = vehicleTypeValue
        keywordTemp.fromDate = fromDateValue
        keywordTemp.toDate = toDateValue
        setKeyword(keywordTemp);
        getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[])

    // Toggle Form to open and close modal form
    const handleToggleForm = () => {
        setValidateForm(false)
        setFormAttribute(prevState => {
            return {...prevState, data: {
                vckode:'',
                vcnama:'',
                vcnopol:'',
                inttypeangkutan:'',
                intrute_angkutan_id:''
            }}
        })
        setShowForm(!showForm);
    }

    // Toggle Form to open and close modal detail
    const handleToggleDetail = () => {
        setShowDetail(!showDetail);
    }

    // to open modal form (ADD)
    const handleAdd = () => {
        setFormAttribute(prevState => {
            return {...prevState, title: 'Form Tambah Data', type: 'add'};

        })
        setShowForm(true);
    }

    // to open modal form (UPDATE)
    const handleEdit = async (intid) => {
        setLoadingForm(true);
        try {
            const response = await axios.get(`${DATA_URL}/${intid}`, HEADER_AUTHORIZATION);
            const responseData = response.data;
            const dataTemp = {
                intid: responseData.data.intid,
                vckode: responseData.data.vckode,
                vcnama: responseData.data.vcnama,
                vcnopol: responseData.data.vcnopol,
                inttypeangkutan: responseData.data.inttypeangkutan,
                intrute_angkutan_id: responseData.data.intrute_angkutan_id,
            }

            setFormAttribute(prevState => {
                return {...prevState, data: dataTemp, title: 'Form Ubah Data', type: 'update'}
            })

            setShowForm(true);
            setLoadingForm(false);
        } catch (err) {
            setLoadingForm(false);
            if (err.response) {
                if (err?.response.status === 401) {
                    toast.error(err?.response.data.message);
                    localStorage.removeItem('accessUser');
                    navigate('/login');
                } else {
                    const response = err.response.data;
                    setShowAlert(prevState => { return {...prevState, show: true, message: response.message, type: 'error'} })
                }
            } else {
                setShowAlert(prevState => { return {...prevState, show: true, message: 'Something error with server. Please call administrator or developer.', type: 'error'} })
            }
        }
    }

    const handleDelete = (intid) => {
        setFormAttribute(prevState => {
            const dataTemp = {
                intid: intid
            }
            return {...prevState, data: dataTemp, title: 'Form Hapus Data', type: 'delete'}
        })
        setShowAlert(prevState => { return {...prevState, show: true, message: 'Data akan dihapus ?', type: 'warning', confirmButton: true} })
    }

    const handleDetail = async (intid) => {
        setLoadingForm(true);
        try {
            const response = await axios.get(`${DATA_URL}/${intid}`, HEADER_AUTHORIZATION);
            const responseData = response.data;
            const dataTemp = {
                intid: responseData.data.intid,
                vckode: responseData.data.vckode,
                vcnama: responseData.data.vcnama,
                vcnopol: responseData.data.vcnopol,
                vcrute: responseData.data.vcrute,
                inttypeangkutan: responseData.data.inttypeangkutan,
                intrute_angkutan_id: responseData.data.intrute_angkutan_id,
            }

            setFormAttribute(prevState => {
                return {...prevState, data: dataTemp, title: 'Form Ubah Data', type: 'update'}
            })

            setShowDetail(true);
            setLoadingForm(false);
        } catch (err) {
            setLoadingForm(false);
            if (err.response) {
                if (err?.response.status === 401) {
                    toast.error(err?.response.data.message);
                    localStorage.removeItem('accessUser');
                    navigate('/login');
                } else {
                    const response = err.response.data;
                    setShowAlert(prevState => { return {...prevState, show: true, message: response.message, type: 'error'} })
                }
            } else {
                setShowAlert(prevState => { return {...prevState, show: true, message: 'Something error with server. Please call administrator or developer.', type: 'error'} })
            }
        }
    }

    const handleChangeForm = (event) => {
        const {value, name} = event.target;
        if (name === 'q' || name === 'parking_location' || name === 'vehicle_type') {
            setKeyword(prevState => {
                return {...prevState, [name]: value};
    
            })
        } else if (name === 'report_type') {
            let startDate = moment().format('YYYY-MM-DD');
            let endDate = moment().format('YYYY-MM-DD');
            if (parseFloat(value) === 2) {
                startDate = moment().startOf('month').format('YYYY-MM-DD');
                endDate = moment().endOf('month').format('YYYY-MM-DD');
            }
            if (parseFloat(value) === 3) {
                startDate = moment().startOf('year').format('YYYY-MM-DD');
                endDate = moment().endOf('year').format('YYYY-MM-DD');    
            }
            setKeyword(prevState => {
                return {...prevState, [name]: value, fromDate: startDate, toDate: endDate, month: moment().format('M'), year: moment().format('YYYY')};
            })
        } else if (name === 'month') {
            const startDate = moment().format('YYYY-' + value + '-01');
            const endDate = moment(startDate).endOf('month').format('YYYY-MM-DD');
            setKeyword(prevState => {
                
                return {...prevState, [name]: value, fromDate: startDate, toDate: endDate};
    
            })
        } else if (name === 'year') {
            const startDate = moment().format(value + '-01-01');
            const endDate = moment(startDate).endOf('year').format('YYYY-MM-DD');
            setKeyword(prevState => {
                
                return {...prevState, [name]: value, fromDate: startDate, toDate: endDate};
    
            })
        } else if (name === 'limit') {
            setPagination(prevState => {
                return {...prevState, limit: value}
            })
            const page = 1;
            const keywordSearch = keyword;
            const pathUrl = window.location.pathname;
            const urlNavigate = `${pathUrl}?q=${keywordSearch}&page=${page}`
            navigate(urlNavigate)
            getData(1, value)
        } else {
            let formDataTemp = formAttribute.data; 
            formDataTemp[name] = value;
            setFormAttribute(prevState => {
                return {...prevState, data: formDataTemp};
    
            })
        }
    }

    const handleChangeDate = (value, name) => {
        setKeyword(prevState => {
            return {...prevState, [name]: moment(value).format('YYYY-MM-DD')};
        })
    }

    const handleSearch = (event) => {
        event.preventDefault();
        event.stopPropagation();
        const page = 1;
        const keywordSearch = keyword.q;
        const keywordParkingLocation = keyword.parking_location;
        const keywordVehicleType = keyword.vehicle_type;
        const keywordFromDate = moment(keyword.fromDate).format('YYYY-MM-DD');
        const keywordToDate = moment(keyword.toDate).format('YYYY-MM-DD');
        const pathUrl = window.location.pathname;
        const urlNavigate = `${pathUrl}?q=${keywordSearch}&from=${keywordFromDate}&to=${keywordToDate}&parking_location=${keywordParkingLocation}&vehicle_type=${keywordVehicleType}&page=${page}`
        navigate(urlNavigate)
        getData(page)
    }

    const handleClickPagination = (type) => {
        let count = 0;
        if (type === 'prev') {
            count = -1
        }
        if (type === 'next') {
            count = 1
        }

        const urlParams = new URLSearchParams(window.location.search);
        const keywordParam = urlParams.get('q');
        const parkingLocationParam = urlParams.get('parking_location');
        const vehicleTypeParam = urlParams.get('vehicle_type');
        const fromDateParam = urlParams.get('from');
        const toDateParam = urlParams.get('to');
        const pageParam = urlParams.get('page');
        const page = pageParam ? parseFloat(pageParam) + count : 2;
        const keywordSearch = keywordParam ? keywordParam : keyword.q;
        const keywordParkingLocation = parkingLocationParam ? parkingLocationParam : keyword.parking_location;
        const keywordVehicleType = vehicleTypeParam ? vehicleTypeParam : keyword.vehicle_type;
        const keywordFromDate = fromDateParam ? fromDateParam : keyword.fromDate;
        const keywordToDate = toDateParam ? toDateParam : keyword.toDate;
        const pathUrl = window.location.pathname;

        if (page > 1) {
            setPagination(prevState => {
                return {...prevState, disabledPrev: false}
            })
        } else {
            setPagination(prevState => {
                return {...prevState, disabledPrev: true}
            })
        }

        const urlNavigate = `${pathUrl}?q=${keywordSearch}&from=${keywordFromDate}&to=${keywordToDate}&parking_location=${keywordParkingLocation}&vehicle_type=${keywordVehicleType}&page=${page}`
        navigate(urlNavigate)
        getData(page, pagination.limit)
    }

    const handleSubmit = (event) => {
        setLoadingForm(true);

        const form = event.currentTarget;
        event.preventDefault();
        event.stopPropagation();

        if (form.checkValidity() === false) {
            setValidateForm(true);
            setLoadingForm(false);
        } else {
            if (formAttribute.type === 'add') {
                createData();
            }
            if (formAttribute.type === 'update') {
                updateData();
            }
        }
    
    };

    const createData = async () => {
        try {
            const response = await axios.post(`${DATA_URL}`, formAttribute.data, HEADER_AUTHORIZATION);
            const responseData = response.data;
            setLoadingForm(false);
            toast.success(`${responseData.message}`, {
                theme: 'colored',
                position: "top-center"
            });
            handleToggleForm();
            getData();
        } catch (err) {
            setLoadingForm(false);
            if (err.response) {
                if (err?.response.status === 401) {
                    toast.error(err?.response.data.message);
                    localStorage.removeItem('accessUser');
                    navigate('/login');
                } else {
                    const response = err.response.data;
                    setShowAlert(prevState => { return {...prevState, show: true, message: response.message, type: 'error'} })
                }
            } else {
                setShowAlert(prevState => { return {...prevState, show: true, message: 'Something error with server. Please call administrator or developer.', type: 'error'} })
            }
        }
        
    }

    const updateData = async () => {
        try {
            const response = await axios.put(`${DATA_URL}/${formAttribute.data.intid}`, formAttribute.data, HEADER_AUTHORIZATION);
            const responseData = response.data;
            setLoadingForm(false);
            toast.success(`${responseData.message}`, {
                theme: 'colored',
                position: "top-center"
            });
            handleToggleForm();
            getData();
        } catch (err) {
            setLoadingForm(false);
            if (err.response) {
                if (err?.response.status === 401) {
                    toast.error(err?.response.data.message);
                    localStorage.removeItem('accessUser');
                    navigate('/login');
                } else {
                    const response = err.response.data;
                    setShowAlert(prevState => { return {...prevState, show: true, message: response.message, type: 'error'} })
                }
            } else {
                setShowAlert(prevState => { return {...prevState, show: true, message: 'Something error with server. Please call administrator or developer.', type: 'error'} })
            }
        }
    }

    const deleteData = async () => {
        try {
            const response = await axios.delete(`${DATA_URL}/${formAttribute.data.intid}`, HEADER_AUTHORIZATION, formAttribute.data);
            const responseData = response.data;
            setLoadingForm(false);
            toast.success(`${responseData.message}`, {
                theme: 'colored',
                position: "top-center"
            });
            getData();
        } catch (err) {
            setLoadingForm(false);
            if (err.response) {
                if (err?.response.status === 401) {
                    toast.error(err?.response.data.message);
                    localStorage.removeItem('accessUser');
                    navigate('/login');
                } else {
                    const response = err.response.data;
                    setShowAlert(prevState => { return {...prevState, show: true, message: response.message, type: 'error'} })
                }
            } else {
                setShowAlert(prevState => { return {...prevState, show: true, message: 'Something error with server. Please call administrator or developer.', type: 'error'} })
            }
        }
    }

    const handleConfirmAlert = () => {
        setShowAlert(prevState => { return {...prevState, show: false}});
        if (formAttribute.type === 'delete') {
            deleteData();
        }
    }

    const handleClickExport = () => {
        window.open(Config.baseUrlApi + '/report/parking/export/' + keyword.parking_location  + '/' + keyword.vehicle_type + '/' + keyword.fromDate + '/' + keyword.toDate, '_blank')
    }

    return (
        <>
            {/* Page Header */}
            <PageHeader
                title="Rekap Data Parkir"
                description=""
                className="mb-3"
            >
            </PageHeader>

            {/* Data */}
            <DataCard>
                <DataCard.HeaderParking title={''} addAction={handleAdd} keyword={keyword} handleChangeKeyword={handleChangeForm} handleSearch={handleSearch} dataList={dataList} handleChangeDate={handleChangeDate} exportExcel handleClickExport={handleClickExport} />
                <DataCard.Body>
                    <Row className="mb-2">
                        <Col sm={6}>
                            <div><h5>Total Data : {parseFloat(totalData).toLocaleString('ID')}</h5></div>
                        </Col>
                        <Col sm={6}>
                            <div className="float-sm-end"><h5>Total Pendapatan : {parseFloat(totalIncome).toLocaleString('ID')}</h5></div>
                        </Col>
                    </Row>
                    <Data 
                        dataMain={data} 
                        actionEdit={handleEdit} 
                        actionDelete={handleDelete} 
                        actionDetail={handleDetail} 
                        numberStart={pagination.numberStart} 
                        isLoading = {loadingData}
                    />
                    <Row>
                        <Col sm={2}>
                            <Form.Select
                                name="limit"
                                value={pagination.limit}
                                onChange={handleChangeForm}
                            >
                                <option value={10}>10 Baris</option>
                                <option value={20}>20 Baris</option>
                                <option value={30}>30 Baris</option>
                            </Form.Select>
                        </Col>
                        <Col sm={10}>
                            <div className="float-end">
                                <Button variant="primary" size="sm" disabled={pagination.disabledPrev} onClick={() => handleClickPagination('prev')} className="me-2">Sebelumnya</Button>
                                <Button variant="primary" size="sm" disabled={pagination.disabledNext} onClick={() => handleClickPagination('next')}>Selanjutnya</Button>
                            </div>
                        </Col>
                    </Row>
                </DataCard.Body>
            </DataCard>

            {/* Form */}
            <VehicleForm 
                show={showForm}
                handleClose={handleToggleForm}
                formAttribute={formAttribute}
                handleChange={handleChangeForm}
                handleSubmit={handleSubmit}
                isLoading={loadingForm}
                validate={validateForm}
                dataList={dataList}
            />

            {/* Detail Data */}
            <Detail 
                show={showDetail}
                handleClose={handleToggleDetail}
                data={formAttribute.data}
            />

            <ModalAlert 
                type={showAlert.type}
                show={showAlert.show}
                message={showAlert.message}
                onHide={() => setShowAlert(prevState => { return {...prevState, show: false} })}
                onConfirm={handleConfirmAlert}
                confirmButton={showAlert.confirmButton}
            />
        </>
    )
}

Vehicle.propTypes = {}

export default Vehicle;